var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7,17.1C6,18.2,6,15.2,4.5,14.8 M14.9,19.3v-2.9c0.1-0.7-0.2-1.4-0.7-1.9c2.3-0.3,4.8-1.1,4.8-5.2 c0-1-0.4-2-1.1-2.8c0.3-0.9,0.3-1.9-0.1-2.8c0,0-0.9-0.3-2.9,1.1c-1.7-0.5-3.5-0.5-5.2,0c-2-1.4-2.9-1.1-2.9-1.1 C6.4,4.6,6.4,5.6,6.7,6.5C6,7.3,5.6,8.3,5.6,9.3c0,4,2.4,4.9,4.8,5.2c-0.5,0.5-0.7,1.2-0.7,1.9v2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.be04d1f162ca2228aa267ad71cbd8f23.svg";
export { ForwardRef as ReactComponent };